// Cloud's notices: Me's notices part with cloud's destinations below its
// settings, and what keeps the destinations up to date. Cloud tells only the
// registered desktops through the open screens and browsers through web push,
// so Me's switch for the open screen's own OS notifications is not shown.
import { createNoticesScreen } from "@trameria/ui-core";
import { PushQuickSettings } from "./quick";
import { PushSettings, pushSections } from "./settings";

export { cloudNoticesPart } from "./background";
export {
  forgetDeviceBeforeSignOut,
  listenServiceWorkerNavigate,
  registerServiceWorker,
} from "./push";

export const cloudNoticesScreen = createNoticesScreen({
  quickSettings: PushQuickSettings,
  extraSettings: PushSettings,
  extraSections: pushSections,
  deviceSwitch: false,
});
